// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { showShareUtilSelector } from '../../../workspace/header/currentBoardHeader/currentBoardHeaderSelector';

// Components
import MobileShareUtil from './MobileShareUtil';

const MobileHeaderRightSection: React.FC = () => {
    const showShareUtil = useSelector(showShareUtilSelector);

    return <div className="MobileHeaderRightSection right-section">{showShareUtil ? <MobileShareUtil /> : null}</div>;
};

export default MobileHeaderRightSection;
